
import { Flex, LoadingSpin } from '@/components';
import { authorizeUser, gererateCaptcha } from '@/services/user.service';
import uuidv4 from '@/utils/uuidGenerator';
import { useMutation } from '@tanstack/react-query';
import { App, Button, Input } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReloadOutlined } from '@ant-design/icons';
import { AuthorizeUserInitValues, useFormAuthorizeUser } from '@/hooks/app/useFormRestPassword';


enum RestPassSteps {
  EnterUsername,
  VerifyOTP,
  ResetPassword
}

const ResetPassword = ({ changePage }: { changePage: (isLogin: boolean) => void }) => {
  const [t] = useTranslation(['common']);
  const { message } = App.useApp();

  const [step, setStep] = useState(RestPassSteps.EnterUsername);
  const [loading, setLoading] = useState(false);
  const [uuid] = useState(uuidv4());

  const { mutate: getCaptcha, isPending: isCaptchaPending, data: captchaPayload } = useMutation({
    mutationKey: ['/rest/captcha'],
    mutationFn: async () => (await gererateCaptcha({ nonce: uuid })),
  });

  useEffect(() => {
    getCaptcha();
  }, []);
  useEffect(() => {
    console.log('Captcha Payload:', captchaPayload);
  }, [captchaPayload]);


  // const { mutate: mutateAuthorizeUser, isPending: isAuthorizingUser, data: authorizeUserData } = useMutation({
  //   mutationKey: ['/rest/users/reset-password'],
  //   mutationFn: async () => (await authorizeUser({ username: '', captchaEnteredByUser: captcha.data.payload.captcha, captchaValidationCode: captcha.data.payload.validationCode, nonce: uuid })),
  // });


  const onSubmit = useCallback(async ({ username, captcha }: AuthorizeUserInitValues) => {
    const opts = { duration: 2, style: { marginTop: '2rem' } };

    const validationCode = captchaPayload?.data?.payload?.validation;
    if (!validationCode) {
      message.warning({ ...opts, content: t('common:errors.captcha-not-ready') });
      return;
    }

    setLoading(true);
    let success = undefined;
    let status = undefined;
    let errResponse = undefined;
    await authorizeUser({ username, captchaEnteredByUser: captcha, captchaValidationCode: validationCode, nonce: uuid })
      .then(() => success = true)
      .catch((e) => {
        console.error({ e });
        success = false;
        status = e?.response?.status;
        errResponse = e?.response?.data;
      });
    setTimeout(() => {
      if (success) message.success({ ...opts, content: t('common:messages.welcome') });
      else {
        if (status === 400 || status === 401) {
          const errDesc = String(errResponse?.error_description ?? '');
          if (errDesc.includes('User account is locked')) {
            message.error({ ...opts, content: t('common:errors.account-locked-by-operator') });
          }
          else if (errDesc?.includes('User is disabled')) {
            message.error({ ...opts, content: t('common:errors.account-disabled') });
          }
          else if (errDesc?.includes('حساب')) {
            message.error({ ...opts, content: errDesc });
          }
          else {
            message.error({ ...opts, content: t('common:errors.invalid-credentials') });
          }
        }
        else if (status != null && status >= 400) {
          message.error({ ...opts, content: t('common:errors.auth-connect-code', { code: status }) });
        }
        else {
          message.error({ ...opts, content: t('common:errors.auth-connect') });
        }
      }
      setLoading(false);
    }, 1500);
  }, [message, t, captchaPayload]);





  const formik = useFormAuthorizeUser(onSubmit);
  const { values } = formik;


  return (
    <Flex direction='column' gap='1rem' className=''>

      <Flex
        align="center"
        justify="center"
        direction="column"
        className="sidebar-title">
        {t('common:messages.reset-password-title')}
      </Flex>

      {step === RestPassSteps.EnterUsername &&
        <Flex direction="column">
          <Input
            name="username"
            spellCheck="false"
            className="auth-input"
            value={values.username}
            onChange={formik.handleChange}
            placeholder={t('common:labels.username')}
            onKeyDown={e => e.key === 'Enter' ? formik.submitForm() : undefined}
          />
          <Flex>
            <Input
              name="captcha"
              spellCheck="false"
              className="auth-input w-1/2 "
              value={values.captcha}
              onChange={formik.handleChange}
              placeholder={t('common:labels.captcha')}
              onKeyDown={e => e.key === 'Enter' ? formik.submitForm() : undefined}
            />
            <Flex className='w-1/2'>
              {
                isCaptchaPending ? <LoadingSpin className="text-primary" text="" /> :
                  <img src={`data:image/png;base64,${captchaPayload?.data?.payload?.image || ''}`} alt="captcha" className="w-[110px]" />
              }
              <Button onClick={() => getCaptcha()}><ReloadOutlined /></Button>
            </Flex>
          </Flex>
          {/* <button onClick={() => setStep(RestPassSteps.VerifyOTP)}>Verify OTP</button> */}
          <Button
            className="auth-btn mb-0"
            loading={loading}
            disabled={isCaptchaPending || !captchaPayload}
            onClick={formik.submitForm}
          >احراز هویت</Button>
        </Flex>
      }
      {step === RestPassSteps.VerifyOTP &&
        <Flex direction="column">
          <input type="text" placeholder="Enter OTP" />
          <button onClick={() => setStep(RestPassSteps.ResetPassword)}>Reset Password</button>
        </Flex>
      }
      {step === RestPassSteps.ResetPassword &&
        <Flex direction="column">
          <input type="password" placeholder="Enter new password" />
          <input type="password" placeholder="Confirm new password" />
          <button onClick={() => changePage(false)}>Submit</button>
        </Flex>
      }

      <Flex
        inlineFlex
        component="b"
        className="justify-center text-center text-xs cursor-pointer  text-primary-dark"
        onClick={() => changePage(true)}>
        {t('common:labels.login')}

      </Flex>

    </Flex>
  )
}

export default ResetPassword